import { apiService } from "@/services";
import { useMutation, useQuery } from "@tanstack/react-query";
import { handleApiError } from "@/utils";
import queryClient from "@/query-client";
import { DEFAULT_STALE_TIME } from "@/constants";

export interface OrganizationNotificationSettings {
  notifications_enabled: boolean;
  rank_change_threshold: number;
}

const ORGANIZATION_NOTIFICATION_SETTINGS_KEY = ["organization-notification-settings"];

export const useGetOrganizationNotificationSettings = () =>
  useQuery<OrganizationNotificationSettings>({
    queryKey: ORGANIZATION_NOTIFICATION_SETTINGS_KEY,
    queryFn: () =>
      apiService.get<OrganizationNotificationSettings>("/organization/notification-settings"),
    staleTime: DEFAULT_STALE_TIME,
    refetchOnMount: "always",
  });

export const useUpdateOrganizationNotificationSettings = () =>
  useMutation<OrganizationNotificationSettings, unknown, Partial<OrganizationNotificationSettings>>({
    mutationFn: (body) =>
      apiService.put<OrganizationNotificationSettings, Partial<OrganizationNotificationSettings>>(
        "/organization/notification-settings",
        body
      ),
    onSuccess: (data) => {
      queryClient.setQueryData(ORGANIZATION_NOTIFICATION_SETTINGS_KEY, data);
    },
    onError: (error) => handleApiError(error),
  });
